var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDongascienceIconOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8843 9.46287H15.7686V8.34717L16.8843 9.46287Z",
    fill: "#009A53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7686 8.34717H16.8843V9.46287L15.7686 8.34717Z",
    fill: "#008342"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8843 9.46289H15.7686V10.5786L16.8843 9.46289Z",
    fill: "#009143"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8843 13.9287H15.7686V12.813L16.8843 13.9287Z",
    fill: "#57B76F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0005 15.0444H16.8848V13.9287L18.0005 15.0444Z",
    fill: "#64BA6F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8843 13.9287H15.7686V15.0444L16.8843 13.9287Z",
    fill: "#48A86D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7686 15.0444H16.8843V13.9287L15.7686 15.0444Z",
    fill: "#66BF97"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8843 16.1601H15.7686V15.0444L16.8843 16.1601Z",
    fill: "#71C7D1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7686 15.0444H16.8843V16.1601L15.7686 15.0444Z",
    fill: "#2EB6AA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0005 15.0444H16.8848V16.1601L18.0005 15.0444Z",
    fill: "#3DABA4"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8843 16.1602H15.7686V17.2759L16.8843 16.1602Z",
    fill: "#1BB8CE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1904 11.6975H11.3061V10.5786L10.1904 11.6975Z",
    fill: "#44B13F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1904 11.6973H11.3061V12.813L10.1904 11.6973Z",
    fill: "#7FBE26"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4214 9.46287H13.5371V8.34717L12.4214 9.46287Z",
    fill: "#009740"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4214 9.46289H13.5371V10.5786L12.4214 9.46289Z",
    fill: "#22AC38"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5371 10.5786H12.4214V9.46289L13.5371 10.5786Z",
    fill: "#45B035"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3062 10.5786H12.4219V9.46289L11.3062 10.5786Z",
    fill: "#00A040"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6528 9.46287H13.5371V8.34717L14.6528 9.46287Z",
    fill: "#008842"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6528 9.46289H13.5371V10.5786L14.6528 9.46289Z",
    fill: "#00A33E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4219 11.6975H11.3062V10.5786L12.4219 11.6975Z",
    fill: "#5CB531"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3062 10.5786H12.4219V11.6975L11.3062 10.5786Z",
    fill: "#1EAC4B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5371 10.5786H12.4214V11.6975L13.5371 10.5786Z",
    fill: "#43B149"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4219 11.6973H11.3062V12.813L12.4219 11.6973Z",
    fill: "#43B149"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5371 8.34717H14.6528V9.46287L13.5371 8.34717Z",
    fill: "#00A040"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6528 9.46287H15.7685V8.34717L14.6528 9.46287Z",
    fill: "#45B035"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7685 8.34717H14.6528V9.46287L15.7685 8.34717Z",
    fill: "#009143"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6528 9.46289H15.7685V10.5786L14.6528 9.46289Z",
    fill: "#00984F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7685 10.5786H14.6528V9.46289L15.7685 10.5786Z",
    fill: "#00A040"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5371 10.5786H14.6528V9.46289L13.5371 10.5786Z",
    fill: "#43B149"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4214 11.6975H13.5371V10.5786L12.4214 11.6975Z",
    fill: "#6FBA2E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4214 11.6973H13.5371V12.813L12.4214 11.6973Z",
    fill: "#6EBA44"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5371 12.813H12.4214V11.6973L13.5371 12.813Z",
    fill: "#89C125"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3062 12.813H12.4219V11.6973L11.3062 12.813Z",
    fill: "#9DC814"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6528 11.6975H13.5371V10.5786L14.6528 11.6975Z",
    fill: "#8EC43E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5371 10.5786H14.6528V11.6975L13.5371 10.5786Z",
    fill: "#22AC38"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7685 10.5786H14.6528V11.6975L15.7685 10.5786Z",
    fill: "#51B44E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7685 12.813H14.6528V11.6973L15.7685 12.813Z",
    fill: "#7FBE26"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6528 11.6973H13.5371V12.813L14.6528 11.6973Z",
    fill: "#44B13F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5371 12.813H14.6528V11.6973L13.5371 12.813Z",
    fill: "#9DC814"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3062 12.813H12.4219V13.9287L11.3062 12.813Z",
    fill: "#7FBE26"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4214 13.9287H13.5371V12.813L12.4214 13.9287Z",
    fill: "#7CC16D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5371 12.813H12.4214V13.9287L13.5371 12.813Z",
    fill: "#5BB647"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4214 13.9287H13.5371V15.0444L12.4214 13.9287Z",
    fill: "#57B76F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6528 13.9287H13.5371V12.813L14.6528 13.9287Z",
    fill: "#43B149"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5371 12.813H14.6528V13.9287L13.5371 12.813Z",
    fill: "#7DC058"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6528 13.9287H15.7685V12.813L14.6528 13.9287Z",
    fill: "#6CBB5A"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7685 12.813H14.6528V13.9287L15.7685 12.813Z",
    fill: "#8EC43E"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6528 13.9287H15.7685V15.0444L14.6528 13.9287Z",
    fill: "#4DBBAA"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7685 15.0444H14.6528V13.9287L15.7685 15.0444Z",
    fill: "#7DC058"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6528 13.9287H13.5371V15.0444L14.6528 13.9287Z",
    fill: "#59B75B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5371 15.0444H14.6528V13.9287L13.5371 15.0444Z",
    fill: "#87CAAC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4214 16.1601H13.5371V15.0444L12.4214 16.1601Z",
    fill: "#01A3C1"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4214 16.1602H13.5371V17.2759L12.4214 16.1602Z",
    fill: "#00A5E3"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5371 17.2759H12.4214V16.1602L13.5371 17.2759Z",
    fill: "#0093D4"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3062 17.2759H12.4219V16.1602L11.3062 17.2759Z",
    fill: "#20AEE5"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6528 16.1601H13.5371V15.0444L14.6528 16.1601Z",
    fill: "#1BB8CE"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5371 15.0444H14.6528V16.1601L13.5371 15.0444Z",
    fill: "#4DBBAA"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6528 16.1601H15.7685V15.0444L14.6528 16.1601Z",
    fill: "#3AB483"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7685 15.0444H14.6528V16.1601L15.7685 15.0444Z",
    fill: "#3DABA4"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6528 16.1602H15.7685V17.2759L14.6528 16.1602Z",
    fill: "#00A4C5"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7685 17.2759H14.6528V16.1602L15.7685 17.2759Z",
    fill: "#0099D9"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6528 16.1602H13.5371V17.2759L14.6528 16.1602Z",
    fill: "#009FC1"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5371 17.2759H14.6528V16.1602L13.5371 17.2759Z",
    fill: "#20AEE5"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4219 18.3947H11.3062V17.2759L12.4219 18.3947Z",
    fill: "#0079C3"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3062 17.2759H12.4219V18.3947L11.3062 17.2759Z",
    fill: "#0087BE"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4214 18.3947H13.5371V17.2759L12.4214 18.3947Z",
    fill: "#0075C2"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5371 17.2759H12.4214V18.3947L13.5371 17.2759Z",
    fill: "#0097E0"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6528 18.3947H13.5371V17.2759L14.6528 18.3947Z",
    fill: "#008CD6"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5371 17.2759H14.6528V18.3947L13.5371 17.2759Z",
    fill: "#187FC4"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7685 17.2759H14.6528V18.3947L15.7685 17.2759Z",
    fill: "#008CCF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6572 18.3948C10.5506 18.3948 10.4629 18.307 10.4629 18.2004C10.4629 18.1472 10.4848 18.097 10.5193 18.0626L11.3028 17.2791V18.3948H10.6572Z",
    fill: "#0068B7"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5335 8.34717C17.6401 8.34717 17.7278 8.43492 17.7278 8.54148C17.7278 8.59475 17.7059 8.6449 17.6714 8.67937L16.8848 9.46287V8.34717H17.5304H17.5335Z",
    fill: "#007440"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95605 5H9.07176V6.1157L7.95605 5Z",
    fill: "#D01126"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07176 6.1157H7.95605V5L9.07176 6.1157Z",
    fill: "#E72410"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95555 5H6.83984V6.1157L7.95555 5Z",
    fill: "#C81528"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83984 6.1157H7.95555V5L6.83984 6.1157Z",
    fill: "#D80C18"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3061 6.1157H10.1904V5L11.3061 6.1157Z",
    fill: "#E72410"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1901 5H9.07129V6.1157L10.1901 5Z",
    fill: "#E8380D"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07129 6.1157H10.1901V5L9.07129 6.1157Z",
    fill: "#D80C24"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83984 6.11572H7.95555V7.23143L6.83984 6.11572Z",
    fill: "#E94709"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95605 7.23143H9.07176V6.11572L7.95605 7.23143Z",
    fill: "#EA5504"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07176 6.11572H7.95605V7.23143L9.07176 6.11572Z",
    fill: "#DA3915"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95605 7.23145H9.07176V8.34715L7.95605 7.23145Z",
    fill: "#E8380D"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1901 7.23143H9.07129V6.11572L10.1901 7.23143Z",
    fill: "#E72410"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07129 6.11572H10.1901V7.23143L9.07129 6.11572Z",
    fill: "#E83820"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1904 7.23143H11.3061V6.11572L10.1904 7.23143Z",
    fill: "#E8382F"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3061 6.11572H10.1904V7.23143L11.3061 6.11572Z",
    fill: "#E94709"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1904 7.23145H11.3061V8.34715L10.1904 7.23145Z",
    fill: "#E94709"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3061 8.34715H10.1904V7.23145L11.3061 8.34715Z",
    fill: "#E8380D"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1901 7.23145H9.07129V8.34715L10.1901 7.23145Z",
    fill: "#E60039"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07129 8.34715H10.1901V7.23145L9.07129 8.34715Z",
    fill: "#ED6C00"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95605 9.46287H9.07176V8.34717L7.95605 9.46287Z",
    fill: "#F18D00"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95605 9.46289H9.07176V10.5786L7.95605 9.46289Z",
    fill: "#ED6C00"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07176 10.5786H7.95605V9.46289L9.07176 10.5786Z",
    fill: "#F39800"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83984 10.5786H7.95555V9.46289L6.83984 10.5786Z",
    fill: "#F08300"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1901 9.46287H9.07129V8.34717L10.1901 9.46287Z",
    fill: "#EB6100"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07129 8.34717H10.1901V9.46287L9.07129 8.34717Z",
    fill: "#E94709"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1904 9.46287H11.3061V8.34717L10.1904 9.46287Z",
    fill: "#ED6C00"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3061 8.34717H10.1904V9.46287L11.3061 8.34717Z",
    fill: "#EA5504"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1904 9.46289H11.3061V10.5786L10.1904 9.46289Z",
    fill: "#F08300"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3061 10.5786H10.1904V9.46289L11.3061 10.5786Z",
    fill: "#F39800"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1901 9.46289H9.07129V10.5786L10.1901 9.46289Z",
    fill: "#EE7800"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07129 10.5786H10.1901V9.46289L9.07129 10.5786Z",
    fill: "#F6AB00"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95555 11.6975H6.83984V10.5786L7.95555 11.6975Z",
    fill: "#F08300"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83984 10.5786H7.95555V11.6975L6.83984 10.5786Z",
    fill: "#F39800"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95605 11.6975H9.07176V10.5786L7.95605 11.6975Z",
    fill: "#F39800"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07176 10.5786H7.95605V11.6975L9.07176 10.5786Z",
    fill: "#F6AB00"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1901 11.6975H9.07129V10.5786L10.1901 11.6975Z",
    fill: "#F6AB00"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07129 10.5786H10.1901V11.6975L9.07129 10.5786Z",
    fill: "#F39800"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3061 10.5786H10.1904V11.6975L11.3061 10.5786Z",
    fill: "#F18D00"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4219 7.23143H11.3062V6.11572L12.4219 7.23143Z",
    fill: "#DF003A"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5371 8.34715H12.4214V7.23145L13.5371 8.34715Z",
    fill: "#E72418"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4219 7.23145H11.3062V8.34715L12.4219 7.23145Z",
    fill: "#E83820"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3062 8.34715H12.4219V7.23145L11.3062 8.34715Z",
    fill: "#EA5504"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4219 9.46287H11.3062V8.34717L12.4219 9.46287Z",
    fill: "#EB6100"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3062 8.34717H12.4219V9.46287L11.3062 8.34717Z",
    fill: "#E9473F"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5371 8.34717H12.4214V9.46287L13.5371 8.34717Z",
    fill: "#EA5504"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4219 9.46289H11.3062V10.5786L12.4219 9.46289Z",
    fill: "#EB6100"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19431 11.6972C6.08775 11.6972 6 11.6095 6 11.5029C6 11.4497 6.02194 11.3995 6.05641 11.365L6.83991 10.5815V11.6972H6.19431Z",
    fill: "#F5A200"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19431 5C6.08775 5 6 5.08775 6 5.19431C6 5.24759 6.02194 5.29773 6.05641 5.3322L6.83991 6.1157V5H6.19431Z",
    fill: "#B81C22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDongascienceIconOn);
export default __webpack_public_path__ + "static/media/dongascienceIconOn.9f0fff740537a1be06305d77d20f1373.svg";
export { ForwardRef as ReactComponent };